import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-order-by',
  templateUrl: './order-by.component.html',
  styleUrls: ['./order-by.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderByComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
